import { render, staticRenderFns } from "./MspForsageGroupForm.vue?vue&type=template&id=475a7cb5&scoped=true&"
import script from "./MspForsageGroupForm.vue?vue&type=script&lang=js&"
export * from "./MspForsageGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a7cb5",
  null
  
)

export default component.exports